export default "__VITE_ASSET__Ceec4bLQ__"